const firebaseConfig = {
  apiKey: 'AIzaSyC5lRSi9aw4lZ0fTWyh3SB7F2twhdU-xpU',
  authDomain: 'rohit-suthar.firebaseapp.com',
  projectId: 'rohit-suthar',
  storageBucket: 'rohit-suthar.firebasestorage.app',
  messagingSenderId: '139828404027',
  appId: '1:139828404027:web:9fcedcdd229a77d09e211e',
  measurementId: 'G-9RF0BZD833',
};

export default firebaseConfig;